import React, {memo, Suspense} from "react"
// import {Anchor} from "./component"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

export type LinkProps = {
    url: string | null
    text: string | null
    template: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const SecureHelpLink = memo(({template, ...restProps}: LinkProps) => {
    const TemplatedComponent = useTemplatedComponent(template, MANIFEST)

    return (
        <Suspense>
            <TemplatedComponent {...restProps} />
        </Suspense>
    )
})
SecureHelpLink.displayName = "SecureHelpLink"

export default connect(SecureHelpLink)
